import CookieHelper from '../../utils/cookie';
import Client from './client';
import Modal from './views/modal';

class MyAccount2 {
    constructor() {
        window.HONDA = window.HONDA || {};
        window.HONDA.MyAccount2 = this;
        this.callbacks = {
            login: [],
            logout: [],
            close: [],
            expires: [],
        };
        this.client = new Client(this);
        this.modal = new Modal(this);
        this.bind();
    }

    bind() {
        this.addEventListener('login', () => {
            const exp = this.expires();
            if (exp !== null) {
                setTimeout(() => this.onExpires(), exp);
            }
        });
    }

    expires() {
        if (CookieHelper.has('ma2-login')) {
            const data = JSON.parse(CookieHelper.get('ma2-login'));
            return Math.max(+data.exp * 1000 - Date.now(), 0);
        }
    }

    isLoggedIn() {
        if (CookieHelper.has('ma2-login')) {
            const data = JSON.parse(CookieHelper.get('ma2-login'));
            const notExpired = +data.exp * 1000 > Date.now();
            const noRegister = !data.register;
            return notExpired && noRegister;
        }
        return false;
    }

    logout() {
        CookieHelper.remove('ma2-login');
        CookieHelper.remove('ma2-otp-login');
        this.client.flushCacheAll();
        this.onLogout();
        window.location.reload();
    }

    onLogin() {
        this.client.flushCacheAll();
        this.callbacks.login.forEach((cb) => cb());
    }

    onLogout() {
        this.callbacks.logout.forEach((cb) => cb());
    }

    onClose() {
        this.callbacks.close.forEach((cb) => cb());
    }

    onExpires() {
        this.callbacks.expires.forEach((cb) => cb());
    }

    addEventListener(type, cb, immediate) {
        this.callbacks[type]?.push(cb);
        if (
            immediate !== false &&
            ((type === 'login' && this.isLoggedIn()) ||
                (type === 'logout' && !this.isLoggedIn()))
        ) {
            cb();
        }
    }

    showModal(params) {
        const isLoggedIn = this.isLoggedIn();
        if (!isLoggedIn || (isLoggedIn && params?.password)) {
            this.addCallbacks(params);
            this.modal.show(params);
            if(params?.password) {
                this.modal.views['password-send-otp'].populateAndSubmit();
            }
            return true;
        }
        return false;
    }

    addCallbacks(params) {
        const cbs = params?.callbacks;
        if(cbs?.onLogin) { this.callbacks.login.push(cbs.onLogin); }
        if(cbs?.onLogout) { this.callbacks.logout.push(cbs.onLogout); }
        if(cbs?.onClose) { this.callbacks.close.push(cbs.onClose); }
        if(cbs?.onExpires) { this.callbacks.expires.push(cbs.onExpires); }
    }

    id() {
        if (this.isLoggedIn()) {
            const data = JSON.parse(CookieHelper.get('ma2-login'));
            return data.id;
        }
    }
}

const myAccount2 = new MyAccount2();
